import { useMonyawn } from "../context/MonyawnContext";
import {
  createOpportunity,
  createCheckpoint,
  createTask,
  createStageEvent,
  nowIso,
} from "../workflow";
import { createSeedState } from "../seed";
import { OpportunityDraft } from "../context/MonyawnContext.types";

export function useOpportunityCreate() {
  const { state, patchState, setNotice } = useMonyawn();

  const handleOpportunitySubmit = (draft: OpportunityDraft) => {
    if (!state.selectedAccountId || !state.selectedUserId) {
      setNotice({
        tone: "info",
        message: "Set the active account and user before starting an opportunity.",
      });
      return;
    }

    const opportunity = createOpportunity({
      account_id: state.selectedAccountId,
      user_id: state.selectedUserId,
      use_case_id: "monyawn",
      ...draft,
    });

    const profile = {
      ...createSeedState().candidateProfiles[0],
      profile_id: `profile_${opportunity.opportunity_id}`,
      user_id: state.selectedUserId,
      opportunity_id: opportunity.opportunity_id,
      skills_summary: "",
      experience_level: "",
      domain_strengths: "",
      declared_gaps: "",
      user_corrected: false,
      updated_at: nowIso(),
    };

    const checkpoint = createCheckpoint(
      opportunity,
      "Opportunity created",
      "Start end-to-end onboarding",
      "medium",
      "pause_for_input",
      "User, account, and opportunity are present. Resume and job description are still required.",
      "none",
      "low",
    );

    const task = createTask(
      opportunity.opportunity_id,
      "Collect intake artifacts and confirm candidate profile",
      "Customer Success Lead",
      true,
    );

    const stageEvent = createStageEvent(
      opportunity.opportunity_id,
      opportunity.current_stage,
      "created",
      "user",
      state.selectedUserId,
      "Opportunity created from guided intake.",
    );

    patchState(
      (current) => ({
        ...current,
        opportunities: [opportunity, ...current.opportunities],
        candidateProfiles: [profile, ...current.candidateProfiles],
        checkpoints: [checkpoint, ...current.checkpoints],
        tasks: [task, ...current.tasks],
        events: [stageEvent, ...current.events],
        selectedOpportunityId: opportunity.opportunity_id,
      }),
      "Opportunity created and routed into intake.",
    );

    return opportunity;
  };

  return { handleOpportunitySubmit };
}
